<!--
  Sidebar Component Template

  Displays the navigation sidebar with:
  - Panel menu for hierarchical navigation
  - Role-based menu items
  - Active route highlighting
  - Collapsible toggle with floating popup

  Enhanced with ARIA attributes for accessibility.
-->

<nav class="sidebar-container"
     [class.collapsed]="isCollapsed"
     role="navigation"
     aria-label="Primary navigation">
  <h2 class="sr-only">Main Navigation</h2>

  <!-- Toggle button (notch) -->
  <button
    class="sidebar-toggle"
    (click)="toggleCollapse()"
    [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
    [attr.aria-expanded]="!isCollapsed"
    type="button">
    <i class="pi" [class.pi-chevron-left]="!isCollapsed" [class.pi-chevron-right]="isCollapsed"></i>
  </button>

  <!-- Expanded Menu -->
  <div class="sidebar-menu-wrapper" *ngIf="!isCollapsed">
    <p-panelMenu
      [model]="menuItems"
      [multiple]="false"
      styleClass="sidebar-menu"
      role="menu"
      aria-label="Navigation menu">
    </p-panelMenu>
  </div>

  <!-- Collapsed Menu (icons only with popup) -->
  <div class="collapsed-menu" *ngIf="isCollapsed">
    @for (item of menuItems; track item.label) {
      <div class="collapsed-menu-item"
           [class.has-children]="item.items && item.items.length > 0"
           [class.active]="activeItem === item"
           (click)="item.items ? showPopup(item, $event) : navigateAndClose(item.routerLink)"
           [pTooltip]="!item.items ? item.label : undefined"
           tooltipPosition="right">
        <i [class]="item.icon"></i>
      </div>
    }
  </div>

  <!-- First Level Floating Popup -->
  @if (activeItem) {
    <div class="collapsed-popup glass-effect" [style.top.px]="popupPosition.top">
      <div class="popup-header">{{ activeItem.label }}</div>
      <div class="popup-content">
        @for (subItem of activeItem.items; track subItem.label) {
          @if (subItem.items && subItem.items.length > 0) {
            <!-- Has nested children - show as clickable item -->
            <div class="popup-item has-children"
                 [class.active]="activeSubItem === subItem"
                 (click)="showSubPopup(subItem, $event)">
              <span>{{ subItem.label }}</span>
              <i class="pi pi-chevron-right"></i>
            </div>
          } @else {
            <!-- Direct link -->
            <div class="popup-item" (click)="navigateAndClose(subItem.routerLink)">
              {{ subItem.label }}
            </div>
          }
        }
      </div>
    </div>
  }

  <!-- Second Level Floating Popup -->
  @if (activeSubItem) {
    <div class="collapsed-popup sub-popup glass-effect" [style.top.px]="subPopupPosition.top">
      <div class="popup-header">{{ activeSubItem.label }}</div>
      <div class="popup-content">
        @for (childItem of activeSubItem.items; track childItem.label) {
          <div class="popup-item" (click)="navigateAndClose(childItem.routerLink)">
            {{ childItem.label }}
          </div>
        }
      </div>
    </div>
  }
</nav>
